import { render } from "./TicketDisputeResolverDialog.vue?vue&type=template&id=cdc45a36&scoped=true&ts=true"
import script from "./TicketDisputeResolverDialog.ts?vue&type=script&lang=ts"
export * from "./TicketDisputeResolverDialog.ts?vue&type=script&lang=ts"

import "./TicketDisputeResolverDialog.vue?vue&type=style&index=0&id=cdc45a36&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdc45a36"]])

export default __exports__